import { InputDateModal } from "core/inputs/input-date/InputDateModal";
import InputSearchList from "core/inputs/input-search/InputSearchList";
import _ from "lodash";
import { FORM_INFO } from "constants/forms";
import { FormattedMessage } from "react-intl";
import { Table } from "core/table/Table";
import { Typography } from "core/typography/Typography";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  onAdd,
  onChange,
  onChangeInputSubCompany,
  onChangeSubCompany,
  onDelete,
  renderCommonBlock,
} from "utils/tableContentHelper";
import { phoneSize } from "utils/screenSizes";
import Proptypes from "prop-types";
import AlertPopup from "components/alert-popup/AlertPopup";
import { POPUP_STATUS, QUERY_STATUS, MODAL_CONTENT } from "constants/constants";
import { ERROR_HISTORY_COMPANY_HISTORY_MISSING_INPUT } from "constants/popup-codes";
import ModalFooter from "components/modal/ModalFooter";
import { format } from "date-fns";

const ManageCompanyHistory = ({
  userScope,
  companiesByIds,
  companyHistoryList,
  getOptions,
  getUpdatedValues,
  usersByIds,
  lang,
  setElementsToDelete,
  onValidate,
  onClose,
  entityStatus,
  subcontractorBySlug,
}) => {
  const [status, setStatus] = useState();
  const [code, setCode] = useState();
  const setError = (code) => {
    setCode(code);
    setStatus(POPUP_STATUS.ERROR);
  };

  const checkInputs = (data) => {
    let error = null;
    data?.some((e) => {
      if (!e.subcontractor_company_id || !e.establishment_date) {
        error = ERROR_HISTORY_COMPANY_HISTORY_MISSING_INPUT;
        return true;
      }
      return false;
    });
    return error;
  };

  const onClickValidate = () => {
    const error = checkInputs(data);
    if (error) {
      setError(error);
      return;
    }
    onValidate();
  };

  const header = [
    {
      label: {
        key: "subcontractor_company_id",
        value: (
          <FormattedMessage
            id="str_company"
            defaultMessage="Société sous-traitante"
          />
        ),
      },
      icon: "clients",
      width: "fit-content",
    },
    {
      label: {
        key: "siren",
        value: "siren",
      },
      icon: "clients",
      width: "fit-content",
    },
    {
      label: {
        key: "establishment_date",
        value: (
          <FormattedMessage id="effective_date" defaultMessage="Date d'effet" />
        ),
      },
      icon: "calendar",
      width: "fit-content",
    },

    {
      label: {
        key: "updated_by",
        value: (
          <FormattedMessage id="updated_by" defaultMessage="Modifié par" />
        ),
      },
      icon: "user",
      width: "fit-content",
    },
    {
      label: {
        key: "le",
        value: <FormattedMessage id="updated_at" defaultMessage="Le" />,
      },
      icon: "calendar",
      width: "fit-content",
    },
  ];

  const [initialData, setInitialData] = useState(companyHistoryList);
  const [data, setData] = useState(companyHistoryList);
  const [formattedCompanyHistory, setFormattedCompanyHistory] = useState([]);

  useEffect(() => {
    const result = companiesByIds?.map((elm) => ({
      label: elm.company_name,
      value: elm.id,
      isDeleted: elm.deleted,
    }));
    setFormattedCompanyHistory(
      _.chain(result)
        .concat(formattedCompanyHistory)
        .flattenDeep()
        .uniqWith(_.isEqual)
        .value()
    );
  }, [companiesByIds]);

  useEffect(() => {
    if (companyHistoryList?.length > 0) {
      setInitialData(companyHistoryList);
    }
  }, [initialData, companyHistoryList]);

  useEffect(() => {
    if (_.isEqual(initialData, companyHistoryList) && initialData?.length > 0) {
      setData(
        _.map(initialData, (elm) => ({
          ...elm,
          updated_by: usersByIds.find((usr) => usr.id === elm.updated_by)?.name,
        }))
      );
    }
  }, [initialData, usersByIds]);

  const formatContent = (content) => {
    return (
      content?.map((elm, index) => {
        const dataTestIndex = content.length - 1 - index;
        return {
          id: elm?.id,
          subcontractor_company_id: (
            <InputSearchList
              limitChoice={1}
              onDelete={onDelete}
              options={formattedCompanyHistory?.filter((e) => !e?.isDeleted)}
              popup={FORM_INFO.subCompany.popup}
              selectedOptions={formattedCompanyHistory.filter(
                (br) => br.value === elm.subcontractor_company_id
              )}
              minLength={2}
              getOptions={getOptions}
              setValue={(val) => {
                onChangeSubCompany({
                  getUpdatedValues,
                  id: elm?.id,
                  key: "subcontractor_company_id",
                  setData,
                  data,
                  val,
                });
              }}
              onChangeInput={() =>
                onChangeInputSubCompany({
                  getUpdatedValues,
                  id: elm?.id,
                  setData,
                  data,
                })
              }
              dataTestId={`${MODAL_CONTENT.MANAGE_COMPANY_HISTORY}_modal-subcontractor_company-${dataTestIndex}`}
            />
          ),
          siren: _.chain(companiesByIds)
            .find((e) => e.id === elm.subcontractor_company_id)
            .get("siren")
            .value(),

          establishment_date: (
            <div
              data-testid={`${MODAL_CONTENT.MANAGE_COMPANY_HISTORY}_modal-establishment_date-${dataTestIndex}`}
            >
              <InputDateModal
                lang={lang}
                elm={elm}
                onChange={(date) => {
                  const formattedDate = date ? format(date, "yyyy-MM-dd") : "";
                  onChange({
                    getUpdatedValues,
                    id: elm?.id,
                    key: "establishment_date",
                    setData,
                    data,
                    val: formattedDate,
                  });
                }}
              />
            </div>
          ),
          ...renderCommonBlock({
            data,
            getUpdatedValues,
            id: elm.id,
            onDelete,
            setData,
            updated_at: elm.updated_at,
            updated_by: elm.updated_by,
            lang,
            setElementsToDelete,
            deleteBtnTestId: `${MODAL_CONTENT.MANAGE_COMPANY_HISTORY}_modal-delete_btn-${dataTestIndex}`,
          }),
        };
      }) || []
    );
  };
  return (
    <>
      <div
        style={{ display: "flex", flexDirection: phoneSize ? "column" : "row" }}
      >
        <button
          className="button-style"
          onClick={() => onAdd({ header, data, setData })}
          data-testid={`${MODAL_CONTENT.MANAGE_COMPANY_HISTORY}_modal-add_subcontractor_company_btn`}
        >
          <Typography
            className="link-1 violet "
            type="h2"
            label={
              <>
                + <FormattedMessage id="add" defaultMessage="Ajouter" />
              </>
            }
          />
        </button>
        <Link
          to={`/${userScope}/subcontractor-company/creation`}
          state={{
            subcontractorId: subcontractorBySlug?.id,
          }}
          className="link"
          data-testid={`${MODAL_CONTENT.MANAGE_COMPANY_HISTORY}_modal-create_and_associate_company_btn`}
        >
          <Typography
            className="link-1 violet "
            type="h2"
            label={
              <>
                +{" "}
                <FormattedMessage
                  id="automatically_create_and_associate_a_new_company"
                  defaultMessage="Créer et associer automatiquement une nouvelle société"
                />
              </>
            }
          />
        </Link>
      </div>
      <br />
      <AlertPopup
        code={code}
        setCode={setCode}
        setStatus={setStatus}
        status={status}
      />
      <Table
        id="company_history"
        header={header}
        content={formatContent(data)}
        tableOverflow={"auto"}
        tableWidth={phoneSize ? "max-content" : "100%"}
      />
      <br />
      <br />
      <ModalFooter
        onClose={onClose}
        onValidate={() => onClickValidate()}
        disabled={entityStatus === QUERY_STATUS.LOADING}
        modalType={MODAL_CONTENT.MANAGE_COMPANY_HISTORY}
      />
    </>
  );
};

export default ManageCompanyHistory;

ManageCompanyHistory.propTypes = {
  userScope: Proptypes.string,
  companiesByIds: Proptypes.array,
  companyHistoryList: Proptypes.array,
  getOptions: Proptypes.func,
  getUpdatedValues: Proptypes.func,
  usersByIds: Proptypes.array,
  lang: Proptypes.string,
  setElementsToDelete: Proptypes.func,
  onValidate: Proptypes.func,
  onClose: Proptypes.func,
  entityStatus: Proptypes.string,
  subcontractorBySlug: Proptypes.object,
};
